var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 23,
    viewBox: "0 0 40 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 22.2222,
    transform: "translate(0 0.5)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M3.73723 10.0522C3.3467 10.4427 3.3467 11.0759 3.73723 11.4664L10.1012 17.8303C10.4917 18.2209 11.1249 18.2209 11.5154 17.8303C11.9059 17.4398 11.9059 16.8067 11.5154 16.4161L5.85855 10.7593L11.5154 5.10242C11.9059 4.7119 11.9059 4.07873 11.5154 3.68821C11.1249 3.29769 10.4917 3.29769 10.1012 3.68821L3.73723 10.0522ZM34.074 11.7593H35.074V9.75928H34.074V11.7593ZM4.44434 11.7593H34.074V9.75928H4.44434V11.7593Z",
    fill: "#4B4B4B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.ba014f731045686c2194809175c96364.svg";
export { ForwardRef as ReactComponent };